<h2 mat-dialog-title>Repairing {{ data.scannedDate }}</h2>

<mat-dialog-content>
  <div class="running">
    <mat-spinner diameter="36"></mat-spinner>
    <div class="running__text">
      <p class="running__now">Running — {{ elapsedLabel }} elapsed</p>
      <p class="running__hint">This usually takes a few seconds. Please leave this tab open.</p>
    </div>
  </div>

  <!-- Listed so the operator knows what is being done to their data, in the order it happens.
       Not ticked off: the run is a single request, so the browser cannot know which step the
       server is on, and animating a guess would be worse than saying nothing. -->
  <ol class="steps">
    <li>
      Writing <strong>{{ data.idCount }}</strong> transaction id{{ data.idCount === 1 ? '' : 's' }},
      each checked against the row it belongs to first
    </li>
    <li>Correcting the statuses this scan read at KapCharge</li>
    <li>Posting an NSF into NLS for every payment that came back returned</li>
  </ol>

  <p class="warn">
    <mat-icon>info</mat-icon>
    <span>Closing this tab will not stop the repair — it runs on the server. You would just
      lose the list of payments to check in NLS afterwards.</span>
  </p>
</mat-dialog-content>
